import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import {  resetUpload } from '../actions'
import InlineButton from './InlineButton';

const CertificateUpload = ({ uploadedCertificate, exitedCertificate, newCertificate, vaccinationStatus, onChange, dispatch}) => {
  const { status } = useSelector(state => state.uploader)
  const [newUpload, setNewUpload] = useState(!uploadedCertificate)

  useEffect(() => {
    if (status !== 'Success') return

    dispatch(resetUpload())
  }, [status])

  useEffect(() => {
    setNewUpload(false)
  }, [vaccinationStatus])

  return (
    <div className="form-group">
      {uploadedCertificate && (
        <p>
          You have uploaded the Covid {_.capitalize(exitedCertificate)} Certificate.
          {' '}
          <InlineButton type="button" onClick={() => setNewUpload(true)}>Click here</InlineButton>
          {' '}
          if you want to upload a new certificate.
        </p>
      )}
      {(newUpload || !uploadedCertificate) && (
        <>
          <ControlLabel htmlFor="file"> Covid {_.capitalize(newCertificate)} Certificate </ControlLabel>
          <FormControl
            id="file"
            type="file"
            componentClass="input"
            onChange={e => onChange('certificate', e.target.files[0], true, false)}
          />
        </>
      )}
    </div>
  )
};

export default CertificateUpload
